import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import { REQUEST_DOCUMENT_STEP } from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash-es";
import mime from "mime";
import mrz from "mrz";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { readOCRPassport } from "redux/modules/passportSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import { selectCurrentDocument, uploadPassport } from "redux/modules/visaForm";
import FileService from "services/FileService";

const x = mrz.parse;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: 0,
  },
  buttonUpload: {
    // margin: theme.spacing(1),
    height: 44,
  },
}));

function UploadButton({ id, onChange, title }) {
  const classes = useStyles();
  return (
    <div>
      <input
        style={{ display: "none" }}
        id={`contained-button-file-${id}`}
        type="file"
        onChange={onChange}
      />
      <label htmlFor={`contained-button-file-${id}`}>
        <ColorButton
          component="span"
          fullWidth={false}
          classes={{ root: classes.buttonUpload }}
          variant="outlined"
        >
          {title || "BROWSE"}
        </ColorButton>
      </label>
    </div>
  );
}

export default function UploadPassport() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isFileFromAPI, setFileFromAPI] = useState(false);
  const [passportFile, setPassportFile] = useState(null);
  const [uploadPassportData, setUploadPassport] = useState(null);
  const canEdit = useSelector(canEditForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const passportState = useSelector((state) => state.passport);
  const currentDocumentState = useSelector(selectCurrentDocument);

  const { showLoading, hideLoading } = useModalLoading();

  console.log(personalDetail);
  const personalId = get(personalDetail, "personalID", "");
  const fileID = get(personalDetail, "fileID", "");
  const fileName = get(personalDetail, "fileName", "");
  const ext = get(personalDetail, "ext", ".txt");
  const fileFullName = `${fileName}${ext}`;

  useEffect(() => {
    const getPassport = async () => {
      const data = await FileService.getFile(fileID);

      console.log(data);
      try {
        const blobFile = new File([data], fileFullName, {
          type: mime.getType(ext),
        });

        setFileFromAPI(true);
        setPassportFile(blobFile);
        setUploadPassport(blobFile);
      } catch (error) {
        console.error(error);
      }
    };

    if (fileID) {
      getPassport();
    }
  }, [ext, fileFullName, fileName, fileID]);

  useEffect(() => {
    if (passportState) {
      if (passportState.isSuccess || passportState.isFailure) {
        hideLoading();
        setUploadPassport(passportFile);
      }
    }
  }, [passportState, hideLoading, passportFile]);

  const handleUploadContractTerm = async (event) => {
    setPassportFile(event.target.files[0]);
    dispatch(readOCRPassport(event.target.files[0]));
    showLoading();
  };

  const handleOnNext = () => {
    if (!canEdit) {
      dispatch(setSmartFormStep(SMART_T_STEP.PART_A_1));
      return;
    }
    if (isFileFromAPI && fileFullName === passportFile?.name) {
      dispatch(setSmartFormStep(SMART_T_STEP.PART_A_1));
    } else {
      showLoading();
      dispatch(uploadPassport(passportFile));
    }
  };

  useEffect(() => {
    if (currentDocumentState) {
      if (currentDocumentState.isSuccess && canEdit) {
        hideLoading();
        dispatch(setSmartFormStep(SMART_T_STEP.PART_A_1));
      }
    }
  }, [currentDocumentState, dispatch, hideLoading]);

  return (
    <div className={classes.root}>
      <ContentTitle
        title="Upload Passport"
        subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “T”"
      />

      <Steper currentStep={0} stepInfo={REQUEST_DOCUMENT_STEP} />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "collumn",
          marginTop: 116,
          marginBottom: 85,
        }}
      >
        <img src="/assets/images/passport.jpg" alt="passport-mask" />
      </div>

      <div style={{ backgroundColor: "#f7fafc", padding: "29px 82px" }}>
        <Typography variant="h6">File Upload</Typography>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            marginTop: 21,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <img src="/assets/pdf.svg" alt="pdf-icon" />
            <div style={{ marginLeft: 34 }}>
              <Typography>Passport</Typography>
              <Typography>{passportFile?.name || "File name: -"}</Typography>
            </div>
          </div>

          {uploadPassportData ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <ColorButton
                style={{ height: 44 }}
                variant="contained"
                color="secondary"
                onClick={() =>
                  window.open(URL.createObjectURL(passportFile), "_blank")
                }
              >
                VIEW
              </ColorButton>
              <div style={{ marginLeft: 8 }}>
                <UploadButton
                  disabled={!canEdit}
                  onChange={handleUploadContractTerm}
                  title="EDIT"
                />
              </div>
            </div>
          ) : (
            <UploadButton disabled={!canEdit} onChange={handleUploadContractTerm} />
          )}
        </div>
      </div>

      {/* <p>Raw text: {passportState?.ocrText + " "}</p>
      <p>countryCode: {passportState?.detail?.countryCode + "" || ""}</p>
      <p>firstName: {passportState?.detail?.firstName + "" || ""}</p>
      <p>lastName: {passportState?.detail?.lastName + "" || ""}</p> */}
      {/* <p>Raw text: {JSON.stringify(uploadPassport)}</p>
      <p>Status: {uploadPassportStatus}</p>
      <p>Progress: {passportProgress * 100} %</p>
      <p>PassportDetail: {JSON.stringify(passportDetail)}</p> */}

      <div
        style={{
          marginTop: 44,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <ColorButton
          style={{ height: 40, width: 125 }}
          variant="outlined"
          color="primary"
          onClick={() => {
            dispatch(setSmartFormStep(SMART_T_STEP.NONE));
          }}
        >
          Back
        </ColorButton>
        <ColorButton
          style={{ height: 40, width: 125, marginLeft: 20 }}
          variant="contained"
          color="primary"
          onClick={handleOnNext}
          disabled={
            !uploadPassportData ||
            passportState.isLoading ||
            currentDocumentState.isLoading
          }
        >
          Next
        </ColorButton>
      </div>
    </div>
  );
}
